import { Button } from '@creditornot/cb-button';
import { MenuLinkItemProps } from '@creditornot/cb-menu';
import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

const NavigationButton = styled(Button)`
  display: flex;
  width: 100%;
  justify-content: start;
`;

type Props = {
  label: string | React.ReactNode;
  href: string;
  icon?: React.ReactNode;
  exact?: boolean;
} & MenuLinkItemProps;

export const ImageGalleryNavigationItem = ({ label, href, icon, exact = false }: Props) => {
  const match = useRouteMatch({
    path: href,
    exact,
  });

  return (
    <Link to={href} style={{ display: 'flex' }}>
      <NavigationButton variant={Boolean(match) ? 'lightBlue' : 'white'} icon={icon} size="small">
        {label}
      </NavigationButton>
    </Link>
  );
};
